import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import * as Yup from "yup";

import { yupObjectValidation } from "../../../validationServices";

export const useSetPasswordValidationSchema = () => {
  const initialValues = {
    password: "",
    confirmpassword: "",
  };

  const intl = useIntl();

  const validationSchema = {
    password: Yup.string()
      .min(8, <FormattedMessage id="YUP.MINIMUM_8" />)
      .max(20, <FormattedMessage id="YUP.MAXIMUM_20" />)
      .matches(
        /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,20}$/,
        intl.formatMessage({ id: "YUP_PASSWORD_PETTERN" }),
      )
      .required(<FormattedMessage id="YUP_PASSWORD_REQUIRED" />),
    confirmpassword: yupObjectValidation.change_password,
  };

  const setPasswordValidationSchema = Yup.object().shape(validationSchema);

  return {
    initialValues,
    setPasswordValidationSchema,
  };
};
